import React from 'react';
import { translate } from 'react-i18next';
import { Platform } from 'react-native';
import { connect } from 'react-redux';
import { IAppStore } from '../reducer';
import { getUrls } from '../../config';
import { closeSetupScreen } from '../actions';
import { DeviceSetupSubScreenHeader } from './DeviceSetup/DeviceSetupSubScreenHeader';
import { WebViewFaqWithBack } from './WebViewFaqWithBack';

interface IProps {
  closeSetupScreen(): void;
  t(key: string): string;
}

const ScreenCasting = ({ t, closeSetupScreen: closeSetupScreenPressed }: IProps) => {
  const { SCREEN_CASTING_FAQ_IOS, SCREEN_CASTING_FAQ_ANDROID } = getUrls();
  const SCREEN_CASTING_FAQ = Platform.OS === 'ios' ? SCREEN_CASTING_FAQ_IOS : SCREEN_CASTING_FAQ_ANDROID;

  return (
    <>
      <DeviceSetupSubScreenHeader title={t('screenCasting')} onBackPress={closeSetupScreenPressed} />
      <WebViewFaqWithBack url={SCREEN_CASTING_FAQ}/>
    </>
  );
};

const mapStateToProps = (state: IAppStore): Partial<IProps> => ({});

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    closeSetupScreen: () => dispatch(closeSetupScreen()),
  };
};

export const ScreenCastingSetup = connect(mapStateToProps, mapDispatchToProps)(
  translate(['homeWorkouts'])(ScreenCasting));
